import styled from 'styled-components';
import { Typography } from '../../global/theme';

const AlertContainer = styled.div`
  padding: 8px;
  border-radius: var(--border-radius-8);
  gap: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  animation: slideIn 0.3s ease;
  background-color: var(--background-primary);
  box-shadow: var(--shadow-dropdown);
  color: var(--text-primary);
  margin-bottom: 10px;
  position: relative;
  z-index: 1000;
  ${Typography.body_lg_medium}

  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
  opacity: 0.6;
  &:hover {
    opacity: 1;
  }
`;

export { CloseButton, AlertContainer };
